<template>
    <!-- 游戏官网 -->
    <div class="Game_index">
       <!-- 导航栏 -->
       <div class="nav_list">
            <router-link class="logo-left" to="/">
              <img src="../assets/logo.png" alt="">
            </router-link>
            <div class="nav_right">
                <div :style="nvaIndex==index?'color:#efb336':''" class="tilte" v-for="(item,index) in gemelist" :key="item.name" @click="daohang(index)">
                    <img v-show="nvaIndex!==index" src="../assets/b_ico.png" alt="">
                    <img v-show="nvaIndex==index" src="../assets/h_ico.png" alt="">
                    <span v-show="$store.state.EnZh">{{item.en_name}}</span>
                    <span v-show="!$store.state.EnZh">{{item.zh_name}}</span>
                    <img v-show="nvaIndex!==index" src="../assets/b_ico.png" alt="">
                    <img v-show="nvaIndex==index" src="../assets/h_ico.png" alt="">
                </div>
                <img v-show="$store.state.EnZh" src="../assets/famyi_bai.png" class="xuanzekuang" alt="" @click="changeEn()">
                <img v-show="!$store.state.EnZh" src="../assets/wen_bai.png" style="width: 32px;" alt="" class="xuanzekuang" @click="changeEn()">
            </div>
            
        </div>
    </div>
  </template>
  <script>
    export default {
      data() {
        return {
          language:'中文',
          gemelist:[
            {zh_name:'游戏下载',en_name:'Download'},
            {zh_name:'游戏特色',en_name:'Feature'}
          ],
          nvaIndex:-1,
          
        }
      },
      methods: {
        //切换语言
        changeEn(){
          if(this.$i18n.locale=='zh'){
            this.$i18n.locale='en';
            this.$store.state.EnZh= true;
            console.log(this.$store.state.EnZh)
            localStorage.setItem('lang', 'en');
          }else{
            this.$i18n.locale='zh';
            this.$store.state.EnZh= false;
            console.log(this.$store.state.EnZh)
            localStorage.setItem('lang', 'zh');
          }
        },
        // 跳转游戏官网
        qiehuan(command) {
            this.language = command
        },
        //导航
        daohang(index){
          this.nvaIndex = index;
          switch(index){
            case 0:
              this.$router.push('/')
              break;
            case 1:
              this.$router.push('/')
              break;
            case 2:
             
              break;
            case 3:
              
              break;
          }
        },
        
       
      }
    }
  </script>
  <style scoped lang="scss">
    .Game_index{
      width: 100%;
      height: 70px;
      position: fixed;
      top: 0;
      z-index: 100;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .nav_list{
          width: 100%;
          height: 70px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          background-color: rgb(0, 0, 0);
          z-index: 100;
          position: fixed;
          .logo-left{
            width: 110px;
            margin-left: 6%;
            img{
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .nav_right{
            margin-right: 2%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .tilte{
              width: 135px;
              height: 40px;
              display: flex;
              align-items: center;
              color: #fff;
              font-size: 16px;
              margin-left: 40px;
              justify-content: space-around;
              
              img{
                width: 20px;
                margin-top: 6px;  
              }
            }
          }
          .xuanzekuang{
            width: 35px;
            margin-left: 25px;
            text-align: center;
            color: #fff;
            font-size: 13px;
            .xiala{
              font-size: 14px;
              color: #fff;
             
            }
          }
          
        }
    
      .weichengnian{
        width: 100px;
        position: fixed;
        right:20px;
        bottom: 6%;
        z-index: 100;
      }
    }
  
  </style>